export const BODY_TYPE = 'bodyTypeId';
export const DRIVE_TYPE = 'driveType';
export const ENGINE = 'engine';
export const TRIM = 'styleId';
